<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        :ripple="false"
        class="no-background-hover"
        style="height:24px !important;width:24px !important"
        v-on="on"
      >
        <v-icon color="primary">
          mdi-pencil 
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      title="Additional Deduction"
      text="Update Additional Deduction"
      class="mb-0"
      :loading="loading"
    >
      <v-container v-if="dialog && !loading">
        <v-row>
          <v-col
            cols="12"
            class="pb-0"
          >
            <v-text-field
              v-model="localAdditionalDeduction.amount"
              v-money="money"
              label="Amount"
              prefix="RM"
              outlined
            />
          </v-col>

          <v-col
            cols="12"
            class="pb-0"
          >
            <v-menu
              v-model="dateMenu"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="processDateDisplay"
                  v-validate="'required'"
                  :error-messages="errors.collect('processDateDisplay')"
                  data-vv-name="processDateDisplay"
                  data-vv-as="process date"
                  label="Process Date"
                  class="fix-date-picker-outline-overlap"
                  outlined
                  readonly
                  v-on="on"
                >
                  <template v-slot:prepend-inner>
                    <v-icon>mdi-calendar</v-icon>
                  </template>
                </v-text-field>
              </template>
              <v-date-picker
                v-model="localAdditionalDeduction.date"
                no-title
                type="month"
                @input="dateMenu = false"
              />
            </v-menu>
          </v-col>
        </v-row>
      </v-container> 

      <v-card-actions v-if="dialog && !loading">
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"
          @click="dialog = false"
        >
          Close
        </v-btn>
        <v-btn
          color="hrissecondary"    
          class="white--text px-10" 
          :loading="progressing"
          @click="submitForm"
        >
          Update
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  import { VMoney } from 'v-money'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    directives: { money: VMoney },
    props: {
      record: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: false,
        progressing: false,
        localAdditionalDeduction: null,
        dateMenu: false,
        loading: false,
        money: {
          decimal: '.',
          thousands: ',',
          precision: 2,
          masked: false, /* doesn't work with directive */
        },
      }
    },

    computed: {
      processDateDisplay () {
        return this.localAdditionalDeduction.date ? this.$moment(this.localAdditionalDeduction.date + '-01', 'YYYY-MM-DD').format('MMM YYYY') : ''
      },
    },
    watch: {
      dialog: function (value) {
        if (!value) return
        this.loading = true

        this.localAdditionalDeduction = { ...this.record }

        if (this.localAdditionalDeduction.amount) { this.localAdditionalDeduction.amount = (Math.round((this.localAdditionalDeduction.amount / 100) * 100) / 100).toFixed(2) }
        if (this.localAdditionalDeduction.date) { this.localAdditionalDeduction.date = this.localAdditionalDeduction.date.substring(0, 7) }

        this.loading = false
      },
    },
    methods: {
      submitForm () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return
            this.setProgressing(true)   

            this.$api.companyEmployeeAdditionalDeductions().update(this.record.id, this.prepareFormData())
              .then(res => {
                this.$emit('updated')
                this.$snack({ message: res.data.status })

                this.setProgressing(false)
                this.dialog = false
              })
              .catch((err) => {
                if (err.response.status === 422) {              
                  this.$snack({ 
                    color: 'error',
                    message: err.response.data.status, 
                  })
                }            
            
                this.progressing = false
              })
          })
      },
 
      setProgressing (status) {
        this.progressing = status
      },
      prepareFormData () {
        return {
          amount: this.localAdditionalDeduction.amount.toString().replaceAll(',', ''),
          process_date: this.localAdditionalDeduction.date + '-01',
        }
      },
    },    
  }
</script>

<style scoped>
.no-background-hover::before {
   background-color: transparent !important; 
}

.fix-date-picker-outline-overlap >>> label{
  background: white;
  padding-right:10px;
  margin-left:-25px
}
</style>
